// ==========================================================
// SPROOTE ‚Äî main.js
// All site behaviour, single IIFE
// ==========================================================

(function () {
  'use strict';

  // --------------------------------------------------------
  // 1. NAV SCROLL SHADOW
  // --------------------------------------------------------
  var siteNav = document.querySelector('.site-nav');
  if (siteNav) {
    var onNavScroll = function () {
      if (window.scrollY > 8) {
        siteNav.classList.add('scrolled');
      } else {
        siteNav.classList.remove('scrolled');
      }
    };
    window.addEventListener('scroll', onNavScroll, { passive: true });
    onNavScroll();
  }

  // --------------------------------------------------------
  // 2. MOBILE HAMBURGER MENU
  // --------------------------------------------------------
  var hamburger = document.querySelector('.nav-hamburger');
  var overlay   = document.querySelector('.nav-overlay');
  var closeBtn  = document.querySelector('.nav-overlay-close');

  function openMenu() {
    if (!hamburger || !overlay) return;
    hamburger.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!hamburger || !overlay) return;
    hamburger.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (hamburger && overlay) {
    hamburger.addEventListener('click', function () {
      overlay.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    overlay.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  // --------------------------------------------------------
  // 3. ACTIVE NAV LINK
  // --------------------------------------------------------
  var currentFile = window.location.pathname.split('/').pop() || 'index.html';
  document
    .querySelectorAll('.nav-links a, .nav-overlay a')
    .forEach(function (link) {
      var href = link.getAttribute('href');
      if (href === currentFile || (currentFile === '' && href === 'index.html')) {
        link.classList.add('active');
      }
    });

  // --------------------------------------------------------
  // 4. FAQ ACCORDION (one open at a time)
  // --------------------------------------------------------
  var faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    var trigger = item.querySelector('.faq-q');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('open');
      faqItems.forEach(function (other) { other.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // --------------------------------------------------------
  // 4b. "before you commit." FAQ accordion (soursop)
  //     Independent of main .faq-item ‚Äî own one-open-at-a-time logic.
  // --------------------------------------------------------
  var bycFaqItems = document.querySelectorAll('.byc-faq-item');
  bycFaqItems.forEach(function (item) {
    var question = item.querySelector('.byc-faq-question');
    if (!question) return;
    question.addEventListener('click', function () {
      var isCurrentlyOpen = item.classList.contains('is-open');
      // Close all items
      bycFaqItems.forEach(function (otherItem) {
        otherItem.classList.remove('is-open');
        var icon = otherItem.querySelector('.byc-faq-icon');
        if (icon) icon.textContent = '+';
      });
      // If this one wasn't open, open it
      if (!isCurrentlyOpen) {
        item.classList.add('is-open');
        var icon = item.querySelector('.byc-faq-icon');
        if (icon) icon.textContent = '‚àí';
      }
    });
  });

  // --------------------------------------------------------
  // 5. SUBSCRIBE / ONE-TIME PRICING TOGGLE
  //    (also drives bonus lock + shine on soursop page)
  // --------------------------------------------------------
  var purchaseOptions = document.querySelectorAll('.purchase-option');
  var ctaPriceTargets = document.querySelectorAll('.cta-price-display');

  // Soursop-specific bonus showcase elements (null on other pages)
  var bonusShowcase = document.querySelector('.bonus-showcase');
  var bonusPill     = document.querySelector('.bonus-pill');
  var bonusCardEls  = document.querySelectorAll('.bonus-card');

  var initialPageLoadDone = false;

  function syncBonusLockState(isSub) {
    if (!bonusShowcase) return;
    bonusShowcase.classList.toggle('is-locked', !isSub);
    bonusCardEls.forEach(function (c) { c.classList.toggle('is-locked', !isSub); });
    if (bonusPill) {
      bonusPill.textContent = isSub
        ? 'Free With Subscribe & Save'
        : 'Unlock With Subscribe & Save';
    }
  }

  function triggerBonusShine() {
    if (!bonusCardEls.length) return;
    bonusCardEls.forEach(function (c) {
      c.classList.remove('shine-active');
      // force reflow so the animation re-fires
      void c.offsetWidth;
      c.classList.add('shine-active');
    });
    setTimeout(function () {
      bonusCardEls.forEach(function (c) { c.classList.remove('shine-active'); });
    }, 1300);
  }

  if (purchaseOptions.length) {
    purchaseOptions.forEach(function (opt) {
      opt.addEventListener('click', function () {
        // Already selected ‚Äî no-op
        if (opt.classList.contains('is-selected')) return;

        purchaseOptions.forEach(function (o) {
          o.classList.remove('active');
          o.classList.remove('is-selected');
        });
        opt.classList.add('active');
        opt.classList.add('is-selected');

        var newPrice = opt.getAttribute('data-price');
        if (newPrice) {
          ctaPriceTargets.forEach(function (el) { el.textContent = newPrice; });
        }

        var isSub = opt.classList.contains('purchase-option--sub');
        syncBonusLockState(isSub);
        if (isSub && initialPageLoadDone) triggerBonusShine();
        initialPageLoadDone = true;
      });
    });

    // Mark initial load complete after a tick so first state-sync from default
    // (Subscribe pre-selected in HTML) does NOT trigger the shine.
    setTimeout(function () { initialPageLoadDone = true; }, 0);
  }

  // --------------------------------------------------------
  // 6. THUMBNAIL GALLERY (product pages)
  // --------------------------------------------------------
  var galleryThumbs = document.querySelectorAll('.gallery-thumb');
  var galleryMain   = document.querySelector('.gallery-main');

  if (galleryThumbs.length && galleryMain) {
    galleryThumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.getAttribute('data-idx');
        galleryThumbs.forEach(function (t) {
          t.classList.toggle('active', t.getAttribute('data-idx') === idx);
        });
        var thumbImg = thumb.querySelector('img');
        var mainImg  = galleryMain.querySelector('img');
        if (thumbImg && mainImg) {
          // Real image thumb ‚Äî swap src + alt
          mainImg.src = thumbImg.src;
          mainImg.alt = thumbImg.alt;
        } else {
          // Placeholder thumb ‚Äî swap label text (graceful fallback)
          var lbl      = thumb.querySelector('span');
          var mainSpan = galleryMain.querySelector('.image-placeholder span');
          if (lbl && mainSpan) mainSpan.textContent = lbl.textContent;
        }
      });
    });
  }

  // --------------------------------------------------------
  // 7. STICKY MOBILE CTA ‚Äî triggers after product hero exits viewport
  // --------------------------------------------------------
  var productHero = document.querySelector('.product-hero');
  var stickyCta   = document.querySelector('.sticky-mobile-cta');

  if (productHero && stickyCta) {
    document.body.classList.add('has-sticky-cta');
    var onStickyScroll = function () {
      var rect = productHero.getBoundingClientRect();
      stickyCta.classList.toggle('visible', rect.bottom < 0);
    };
    window.addEventListener('scroll', onStickyScroll, { passive: true });
    onStickyScroll();
  }

  // --------------------------------------------------------
  // 8. INTERSECTION OBSERVER ‚Äî fade in on scroll
  // --------------------------------------------------------
  if ('IntersectionObserver' in window) {
    var ioFade = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          ioFade.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.fade-in, .stars-fade').forEach(function (el) {
      ioFade.observe(el);
    });

    // -------- Timeline steps (soursop) ‚Äî bi-directional fade + gold pulse
    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timelineSteps = document.querySelectorAll('.timeline-item.tl-step');
    if (timelineSteps.length) {
      if (prefersReducedMotion) {
        timelineSteps.forEach(function (step) { step.classList.add('is-visible'); });
      } else {
        var ioTimeline = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              // Restart the gold pulse by removing then re-adding next frame
              var step = entry.target;
              step.classList.remove('is-visible');
              // force reflow so animation can re-trigger
              void step.offsetWidth;
              step.classList.add('is-visible');
            } else {
              entry.target.classList.remove('is-visible');
            }
          });
        }, { threshold: 0.4, rootMargin: '0px 0px -10% 0px' });
        timelineSteps.forEach(function (step) { ioTimeline.observe(step); });
      }
    }

    // --------------------------------------------------------
    // 9. STAT COUNTER ‚Äî animate when in view
    // --------------------------------------------------------
    var ioStats = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target;
        if (entry.isIntersecting) {
          // Reset display, then animate fresh ‚Äî runs every time element enters viewport
          resetCountDisplay(el);
          animateCount(el);
        } else {
          // Reset display when out of viewport so the next entry animates from 0
          resetCountDisplay(el);
        }
      });
    }, { threshold: 0.4 });

    document.querySelectorAll('[data-count]').forEach(function (el) {
      ioStats.observe(el);
    });

    // --------------------------------------------------------
    // 9c. REVIEW TILE STAR SHINE ‚Äî bidirectional, re-fires on re-entry
    // --------------------------------------------------------
    var reviewTiles = document.querySelectorAll('.review-text-tile');
    if (reviewTiles.length) {
      var ioReviewTiles = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var tile = entry.target;
          if (entry.isIntersecting) {
            tile.classList.remove('is-revealed');
            void tile.offsetWidth; // force reflow so animation restarts
            tile.classList.add('is-revealed');
          } else {
            tile.classList.remove('is-revealed');
          }
        });
      }, { threshold: 0.3, rootMargin: '0px 0px -50px 0px' });
      reviewTiles.forEach(function (tile) { ioReviewTiles.observe(tile); });
    }

  } else {
    // Fallback: just show
    document.querySelectorAll('.fade-in, .stars-fade').forEach(function (el) {
      el.classList.add('in-view');
    });
    document.querySelectorAll('.tl-step').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // If [data-count] is a nested-span pattern (parent contains a child [data-count]),
  // we write to that child only ‚Äî preserves static prefix/suffix sibling spans.
  // Otherwise the el IS the count target (flat-text pattern) and uses data-prefix/data-suffix.
  function isNestedCount(el) {
    // True when el itself is the inner [data-count] span (i.e. its parent uses the nested pattern).
    return el.parentElement && el.parentElement.classList.contains('stat-number--with-prefix');
  }

  function formatCount(target, current) {
    return target >= 1000
      ? Math.round(current).toLocaleString()
      : (target % 1 === 0 ? Math.round(current) : current.toFixed(1));
  }

  function resetCountDisplay(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    if (isNestedCount(el)) {
      el.textContent = '0';
    } else {
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      el.textContent = prefix + '0' + suffix;
    }
  }

  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var nested = isNestedCount(el);
    var prefix = nested ? '' : (el.getAttribute('data-prefix') || '');
    var suffix = nested ? '' : (el.getAttribute('data-suffix') || '');
    var duration = 1400;
    var start = performance.now();
    var initial = 0;
    function tick(now) {
      var p = Math.min((now - start) / duration, 1);
      // ease-out cubic
      var eased = 1 - Math.pow(1 - p, 3);
      var current = initial + (target - initial) * eased;
      var display = formatCount(target, current);
      el.textContent = nested ? display : (prefix + display + suffix);
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  // --------------------------------------------------------
  // 9b. LEARN MORE TOGGLE (Why Soursop cards)
  // --------------------------------------------------------
  document.querySelectorAll('.learn-more-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.why-card');
      if (!card) return;
      var content = card.querySelector('.learn-more-content');
      if (!content) return;

      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      var nextOpen = !isOpen;

      btn.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      content.setAttribute('data-open', nextOpen ? 'true' : 'false');
      if (nextOpen) {
        content.removeAttribute('hidden');
        btn.textContent = '‚àí show less';
      } else {
        btn.textContent = '+ learn more';
        // keep hidden attribute off so transition can collapse smoothly
      }
    });
  });

  // --------------------------------------------------------
  // 10. EMAIL FORM INTERCEPT (no real backend)
  // --------------------------------------------------------
  document
    .querySelectorAll('.email-form, .footer-form, .email-split-form')
    .forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[type="email"]');
        var btn = form.querySelector('button');
        if (input && input.value && btn) {
          input.value = '';
          var orig = btn.textContent;
          btn.textContent = 'Subscribed';
          setTimeout(function () { btn.textContent = orig; }, 2500);
        }
      });
    });

  // --------------------------------------------------------
  // 11. CONTACT FORM INTERCEPT
  // --------------------------------------------------------
  var contactForm = document.querySelector('.contact-form');
  if (contactForm) {
    contactForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = contactForm.querySelector('button[type="submit"]');
      if (!btn) return;
      var orig = btn.textContent;
      btn.textContent = 'Message Sent';
      btn.disabled = true;
      contactForm.reset();
      setTimeout(function () {
        btn.textContent = orig;
        btn.disabled = false;
      }, 3000);
    });
  }

})();
